import React from 'react'

import ReadAloud from "../../components/ReadAloud/ReadAloud";

const TeamMembers = ({fontSize}) => {
    return (<div>
        <ReadAloud fontSize={`${16+fontSize}px`}>
        <h4 style={{fontSize: `${20+fontSize}px`}} className="page-name">Aaisha Ameen | Lab Member & Lab Supervisor</h4><ul className="page-text">
        <li>Contributed to lab experiment planning/design</li>
        <li>Researched various methodologies and experimental framework (cannabinoid/terpene selection)</li>
        <li>Contributed to quantification method design </li>
        <li>Conducted wet lab testing and participated in lab upkeep</li>
        </ul>
        </ReadAloud>

        <ReadAloud fontSize={`${16+fontSize}px`}>
        <h4 style={{fontSize: `${20+fontSize}px`}} className="page-name">Adrian Foell | Modelling Member & Modelling Technical Lead & Lab Supervisor</h4><ul className="page-text">
        <li>Led experiments to genetically engineer <i>S. cerevisiae</i></li>
        <li>Created a genomic scale model to model acetyl-CoA production </li>
        <li>Conducted wet lab testing and participated in lab upkeep</li>
        <li>Wiki writing</li>
        </ul>
        </ReadAloud>

        <ReadAloud fontSize={`${16+fontSize}px`}>
        <h4 style={{fontSize: `${20+fontSize}px`}} className="page-name">Amberlee Morgan | Human Practices Member</h4><ul className="page-text">
        <li>Researched and aided in development of current cannabis manufacturing pipeline </li>
        <li>Facilitated contact with major stakeholders </li>
        <li>Contacted over 50 stakeholders </li>
        <li>Researched environmental impacts of cannabis production </li>
        <li>Aided in social media management</li>
        <li>Wiki writing</li>
        </ul>
        </ReadAloud>

        <ReadAloud fontSize={`${16+fontSize}px`}>
        <h4 style={{fontSize: `${20+fontSize}px`}} className="page-name">Amy Wohlgemuth | Modelling Member</h4><ul className="page-text">
        <li>Researched metabolic pathway, enzymes and operational factors to optimize manufacturing process</li>
        <li>Performed bioreactor operational analysis and modelling using Python, supplying production recommendations</li>
        <li>Wiki writing</li>
        </ul>
        </ReadAloud>

        <ReadAloud fontSize={`${16+fontSize}px`}>
        <h4 style={{fontSize: `${20+fontSize}px`}} className="page-name">Andre Villanueva | Modelling Member</h4><ul className="page-text">
        <li>Worked on modelling the terpene precursors in the full model</li>
        <li>Researched MVA pathway optimization to increase GPP yield</li>
        <li>Wiki writing</li>
        </ul>
        </ReadAloud>

        <ReadAloud fontSize={`${16+fontSize}px`}>
        <h4 style={{fontSize: `${20+fontSize}px`}} className="page-name">Anthony Dang | Lab Member & Lab Supervisor </h4><ul className="page-text">
        <li>Helped develop initial project pitch</li>
        <li>Researched suitable enzymes for cannabinoid and terpene production in yeast</li>
        <li>Performed lab experiments (typically yeast transformations)</li>
        <li>Wiki writing</li>
        </ul>
        </ReadAloud>

        <ReadAloud fontSize={`${16+fontSize}px`}>
        <h4 style={{fontSize: `${20+fontSize}px`}} className="page-name">Ashish Kumar | Lab Member</h4><ul className="page-text">
        <li>Assisted with in-lab experimentation, such as running gels</li>
        <li>Researched methods to isolate for CBDs </li>
        <li>Researched methods to regulate product production </li>
        </ul>
        </ReadAloud>

        <ReadAloud fontSize={`${16+fontSize}px`}>
        <h4 style={{fontSize: `${20+fontSize}px`}} className="page-name">Bethany Chan | Lab Member</h4><ul className="page-text">
        <li>Assisted in running online auction</li>
        <li>Participated in Mini-Jamboree presentation</li>
        <li>Collaborated in translating and narrating promotional video</li>
        </ul>
        </ReadAloud>

        <ReadAloud fontSize={`${16+fontSize}px`}>
        <h4 style={{fontSize: `${20+fontSize}px`}} className="page-name">Boya Zhang | WIki Member</h4><ul className="page-text">
        <li>Developed the project wiki</li>
        <li>Worked on styling and implemented accessibility features</li>
        </ul>
        </ReadAloud>

        <ReadAloud fontSize={`${16+fontSize}px`}>
        <h4 style={{fontSize: `${20+fontSize}px`}} className="page-name">Braeden MacDougall | Lab Member</h4><ul className="page-text">
        <li>Researched potential terpene transport mechanisms</li>
        <li>Reviewed literature on precursors to terpenes</li>
        <li>Found Michaelis-Menten constants to assist in predicting experimental results</li>
        </ul>
        </ReadAloud>

        <ReadAloud fontSize={`${16+fontSize}px`}>
        <h4 style={{fontSize: `${20+fontSize}px`}} className="page-name">Brianna Thomas | Human Practices Member</h4><ul className="page-text">
        <li>Helped create the terpene production pipeline and the visuals for the cannabis production pipeline</li>
        <li>Created social media posts in the "oh, gurl" series as well as ones about synthetic biology and accidental discoveries</li>
        <li>Participated in and led collab calls with other iGEM teams</li>
        <li>Assisted with the background illustrations for McMaster iGEM's children's book</li>
        <li>Researched the environmental impact of cannabis cultivation and the use of terpenes in industry</li>
        <li>Wiki writing</li>
        </ul>
        </ReadAloud>

        <ReadAloud fontSize={`${16+fontSize}px`}>
        <h4 style={{fontSize: `${20+fontSize}px`}} className="page-name">Chelsea Huang | Modelling Member</h4><ul className="page-text">
        <li>Researched acetyl-CoA flux equations in <i>S. cerevisiae</i>, helping with modeling reaction for flux-balance analysis</li>
        <li>Compiled list of genes responsible for enzymes of the glycolysis pathway</li>
        <li>Contributed to software programs for analysis of yeast genomes to isolate optimal strains</li>
        <li>Wiki writing</li>
        </ul>
        </ReadAloud>

        <ReadAloud fontSize={`${16+fontSize}px`}>
        <h4 style={{fontSize: `${20+fontSize}px`}} className="page-name">Chimdindu Ohaegbu | Modelling Member</h4><ul className="page-text">
        <li>Collaboratively presented team project to members from six other Canadian iGEM teams at In Vitro 2022 conference.</li>
        <li>Effectively conducted research on design equations and reasonable assumptions for continuously stirred tank bioreactors (CSTR)</li>
        <li>Contributed to determination of growth curve for all bioreactors by integrating experimental data into Python ODE solvers</li>
        <li>Methodically documented research and modelling workflows by writing and editing sections of team wiki</li>
        </ul>
        </ReadAloud>

        <ReadAloud fontSize={`${16+fontSize}px`}>
        <h4 style={{fontSize: `${20+fontSize}px`}} className="page-name">David Felipe Tello Yepes | Lab Member & Lab Supervisor</h4><ul className="page-text">
        <li>Project design for lab experimentation</li>
        <li>Led and conducted wet lab experiments</li>
        <li>Literature research</li>
        <li>Helped design transport system</li>
        <li>Spanish translation and narration for the promotional video</li>
        <li>Helped run fundraising initiatives</li>
        <li>Wiki writing</li>
        </ul>
        </ReadAloud>

        <ReadAloud fontSize={`${16+fontSize}px`}>
        <h4 style={{fontSize: `${20+fontSize}px`}} className="page-name">Dawson McLachlan | Human Practices Member</h4><ul className="page-text">
        <li>Lead/participated in collaboration meetings with other teams from around the world</li>
        <li>Performed research to assist in validation of project direction and applicability of our problem solving</li>
        <li>Assisted running the online auction by speaking with vendors, planning auction dates, and photography of the items for social media posts</li>
        <li>Performed research, writing, and editing for the manufacturing pipeline wiki</li>
        <li>Participated in wet lab training and assisted in wet lab activities when available</li>
        </ul>
        </ReadAloud>

        <ReadAloud fontSize={`${16+fontSize}px`}>
        <h4 style={{fontSize: `${20+fontSize}px`}} className="page-name">Denver Winch | Human Practices Member</h4><ul className="page-text">
        <li>Researched cultivation pipeline</li>
        <li>Conducted cross team collaborations</li>
        <li>Contacted stakeholders</li>
        <li>Contributed to social media outreach</li>
        <li>Wiki write up regarding collaborations</li>
        </ul>
        </ReadAloud>

        <ReadAloud fontSize={`${16+fontSize}px`}>
        <h4 style={{fontSize: `${20+fontSize}px`}} className="page-name">Dorothy Lin | Human Practices Co-Lead</h4><ul className="page-text">
        <li>Co-managed the Human Practices team</li>
        <li>Participated in outreach events and collaborations</li>
        <li>Authored and edited wiki pages related to all human practices content</li>
        </ul>
        </ReadAloud>

        <ReadAloud fontSize={`${16+fontSize}px`}>
        <h4 style={{fontSize: `${20+fontSize}px`}} className="page-name">Elizabeth Sun | Wiki Member</h4><ul className="page-text">
        <li>Designed and developed mock-ups and graphics for wiki and promotional video</li>
        <li>Created promotional video</li>
        </ul>
        </ReadAloud>

        <ReadAloud fontSize={`${16+fontSize}px`}>
        <h4 style={{fontSize: `${20+fontSize}px`}} className="page-name">Ethan Zhang | Finance Co-Lead</h4><ul className="page-text">
        <li>Sought after and secured funding for the team</li>
        </ul>
        </ReadAloud>

        <ReadAloud fontSize={`${16+fontSize}px`}>
        <h4 style={{fontSize: `${20+fontSize}px`}} className="page-name">Faizaan Adtani | Modelling Member</h4><ul className="page-text">
        <li>Utilized COBRA to create a flux balance analysis, flux variability analysis for acetyl-CoA model</li>
        <li>Implemented <i>S. cerevisiae</i> BiGG model to extract its metabolites and essential genes</li>
        <li>Finalized the acetyl-CoA model using Python and Jupyter Notebooks to improve its presentation and output</li>
        <li>Wiki writing</li>
        </ul>
        </ReadAloud>

        <ReadAloud fontSize={`${16+fontSize}px`}>
        <h4 style={{fontSize: `${20+fontSize}px`}} className="page-name">Gerald Lee | Modelling Member</h4><ul className="page-text">
        <li>Researched mathematical models for the MVA pathway</li>
        <li>Unified multiple models to create an overall model for the terpene pathway</li>
        <li>Miscellaneous support for modelling in software</li>
        <li>Wiki writing</li>
        </ul>
        </ReadAloud>

        <ReadAloud fontSize={`${16+fontSize}px`}>
        <h4 style={{fontSize: `${20+fontSize}px`}} className="page-name">Jackie Easson | Human Practices Co-Lead</h4><ul className="page-text">
        <li>Co-managed the Human Practices team</li>
        <li>Helped lead and initiate collaborations</li>
        <li>Worked with the lab team and contacted stakeholders</li>
        <li>Wiki writing</li>
        </ul>
        </ReadAloud>

        <ReadAloud fontSize={`${16+fontSize}px`}>
        <h4 style={{fontSize: `${20+fontSize}px`}} className="page-name">Jacob March | Lab Member & Lab Supervisor</h4><ul className="page-text">
        <li>Contributed to the lab team by researching and developing successful methods for creating meaningful experimental results</li>
        <li>Led as a lab supervisor to maintain lab safety and aid in organization and teaching of processes and experimentation implemented in the lab</li>
        </ul>
        </ReadAloud>

        <ReadAloud fontSize={`${16+fontSize}px`}>
        <h4 style={{fontSize: `${20+fontSize}px`}} className="page-name">Janessa Tang | Lab Member</h4><ul className="page-text">
        <li>Researched potential toggle switch alternatives and genes for cannabinoid production</li>
        <li>Looked into genes required for producing sesquiterpenes</li>
        </ul>
        </ReadAloud>

        <ReadAloud fontSize={`${16+fontSize}px`}>
        <h4 style={{fontSize: `${20+fontSize}px`}} className="page-name">Jessica Zhang | Lab Co-Lead</h4><ul className="page-text">
        <li>Co managed the Lab and Design team</li>
        <li>Led the dry lab plasmid design component and the wet lab work</li>
        <li>Created and added documentation to BioBrick part pages</li>
        <li>Helped with grant applications and fundraising events</li>
        <li>Authored, edited, and organized wiki pages relating to Lab and Design</li>
        </ul>
        </ReadAloud>

        <ReadAloud fontSize={`${16+fontSize}px`}>
        <h4 style={{fontSize: `${20+fontSize}px`}} className="page-name">Joshua Khatri | Human Practices Member</h4><ul className="page-text">
        <li>Helped with the creation of the project pitch</li>
        <li>Aided in the collecting and reaching out to stakeholders</li>
        <li>Heavily researched the environmental impacts of current cannabis cultivation practices</li>
        <li>Aided in the creation of the terpene synthesis pipeline in yeast</li>
        <li>In a group of three, did a mock presentation during the Mini Jamboree held last August</li>
        <li>Wiki writing</li>
        </ul>
        </ReadAloud>

        <ReadAloud fontSize={`${16+fontSize}px`}>
        <h4 style={{fontSize: `${20+fontSize}px`}} className="page-name">Ke Xin (Katie) Chen | Modelling Member & Modelling Technical Lead</h4><ul className="page-text">
        <li>Brainstormed meaningful contribution opportunities for the modelling team</li>
        <li>Technical lead for early research/development on MVA pathway models</li>
        <li>Mandarin narration and translation for the promotional video</li>
        </ul>
        </ReadAloud>

        <ReadAloud fontSize={`${16+fontSize}px`}>
        <h4 style={{fontSize: `${20+fontSize}px`}} className="page-name">Kellie Chong | Modelling Member & Modelling Technical Lead</h4><ul className="page-text">
        <li>Terpene precursors modelling and research</li>
        <li>MVA pathway modelling and research</li>
        <li>Research on optimizing GPP yield</li>
        <li>Wiki writing</li>
        </ul>
        </ReadAloud>

        <ReadAloud fontSize={`${16+fontSize}px`}>
        <h4 style={{fontSize: `${20+fontSize}px`}} className="page-name">Kritika Grover | Lab Member</h4><ul className="page-text">
        <li>Researched genes and methods to produce cannabinoids and terpenes</li>
        <li>Researched HPLC methods to quantify cannabinoid concentration</li>
        </ul>
        </ReadAloud>
        
        <ReadAloud fontSize={`${16+fontSize}px`}>
        <h4 style={{fontSize: `${20+fontSize}px`}} className="page-name">Molly Lu | Human Practices Member</h4><ul className="page-text">
        <li>Social media content creation</li>
        <li>Event representation</li>
        <li>Contribution to stakeholder search  </li>
        <li>Environmental impact research</li>
        <li>Facilitated some cross-team collaboration</li>
        <li>Wiki writing</li>
        </ul>
        </ReadAloud>
        
        <ReadAloud fontSize={`${16+fontSize}px`}>
        <h4 style={{fontSize: `${20+fontSize}px`}} className="page-name">Naomi Thomas | Lab Member</h4><ul className="page-text">
        <li>Researched lab experimental methodologies</li>
        <li>Researched genes for lab</li>
        </ul>
        </ReadAloud>

        <ReadAloud fontSize={`${16+fontSize}px`}>
        <h4 style={{fontSize: `${20+fontSize}px`}} className="page-name">Rachel Zhang | Modelling Member</h4><ul className="page-text">
        <li>Researched and synthesized various mathematical models for terpene production</li>
        <li>Implemented MVA pathway using flux balance analysis for terpene production using literature</li>
        <li>Recommended exogenous and endogenous methodologies to optimize GPP yield</li>
        <li>Wiki writing</li>
        </ul>
        </ReadAloud>
        
        <ReadAloud fontSize={`${16+fontSize}px`}>
        <h4 style={{fontSize: `${20+fontSize}px`}} className="page-name">Rajosree Pal | Lab Co-Lead</h4><ul className="page-text">
        <li>Co-managed the Lab and Design team</li>
        <li>Evaluated overall project design and direction alongside other team leads</li>
        <li>Researched various different cannabinoid and terpene synthesis pathways</li>
        <li>Oversaw logistical planning for lab work regarding materials and facilities alongside co-lead</li>
        <li>Participated in lab work to develop our project</li>
        <li>Represented Waterloo iGEM at conferences and meetings with other iGEM teams</li>
        <li>Organized and assisted with fundraising to support our team and help mitigate costs</li>
        <li>Oversaw lab and design members and provided support when needed alongside co-lead</li>
        </ul>
        </ReadAloud>

        <ReadAloud fontSize={`${16+fontSize}px`}>
        <h4 style={{fontSize: `${20+fontSize}px`}} className="page-name">Rohan Mistry | Modelling Member</h4><ul className="page-text">
        <li>Researched different ways to model terpene precursors to integrate with the entire terpene pathway model</li>
        <li>Part of metabolic pathway engineering, researched the MVA pathway primarily identifying modifications to improve GPP yield</li>
        <li>Programmed the kinetic parameters and initial conditions for the terpene precursors part of the model</li>
        <li>Wiki writing</li>
        </ul>
        </ReadAloud>
        
        <ReadAloud fontSize={`${16+fontSize}px`}>
        <h4 style={{fontSize: `${20+fontSize}px`}} className="page-name">Sabrina Valeri | Finance Co-lead</h4><ul className="page-text">
        <li>Created budget for the team</li>
        <li>Organized finances, submitted funding applications, emailed invoices and explored sources of funding to send members to Paris</li>
        </ul>
        </ReadAloud>
        
        <ReadAloud fontSize={`${16+fontSize}px`}>
        <h4 style={{fontSize: `${20+fontSize}px`}} className="page-name">Sophia Tan | Human Practices Member</h4><ul className="page-text">
        <li>Assisted in creating cannabinoid pipeline visuals</li>
        <li>Authored and edited wiki pages</li>
        <li>Designed social media outreach iGEM posts</li>
        <li>Contacted stakeholders regarding feedback about our project design</li>
        <li>Attended calls with other iGEM teams, garnering information and contributing to Human</li> 
        <li>Practices initiatives such as a recipe book</li>
        </ul>
        </ReadAloud>
        
        <ReadAloud fontSize={`${16+fontSize}px`}>
        <h4 style={{fontSize: `${20+fontSize}px`}} className="page-name">Steven Zhang | Human Practices Member</h4><ul className="page-text">
        <li>Researched the pipelines relating to environmental and economic impacts of marijuana</li>
        <li>Communicated with stakeholders</li>
        <li>Collaborated and communicated with other iGEM teams</li>
        <li>Wiki writing</li>
        </ul>
        </ReadAloud>
        
        <ReadAloud fontSize={`${16+fontSize}px`}>
        <h4 style={{fontSize: `${20+fontSize}px`}} className="page-name">Sydney Sherwood | Modelling Member</h4><ul className="page-text">
        <li>Researched various models of the MVA enzyme pathway to determine an appropriate pathway for the scope of terpene synthesis</li>
        <li>Transcribed model into Python code using SciPy, NumPy and MatPlotLib libraries</li>
        <li>Researched and tested optimizations to improve IDP yield in the MVA pathway</li>
        <li>Travelled to Montreal, Québec to represent Waterloo iGEM at McGill and Concordia University's Mini Jamboree</li>
        <li>Wiki writing</li>
        </ul>
        </ReadAloud>
        
        <ReadAloud fontSize={`${16+fontSize}px`}>
        <h4 style={{fontSize: `${20+fontSize}px`}} className="page-name">Tammy Huynh | Human Practices Member</h4><ul className="page-text">
        <li>Reached out to stakeholders with general questions</li>
        <li>Collaborated with lab and design to conduct lab work</li>
        <li>Wrote and edited sections of the wiki</li>
        </ul>
        </ReadAloud>
        
        <ReadAloud fontSize={`${16+fontSize}px`}>
        <h4 style={{fontSize: `${20+fontSize}px`}} className="page-name">Taylor Roth | Modelling Co-lead</h4><ul className="page-text">
        <li>Co-managed the Math and Modelling subteam</li>
        <li>Completed bioreactor literature research, ODE modelling, and analysis for batch and CSTR reactors</li>
        <li>Found Monod batch reactor parameters by fitting experimental growth rate data</li>
        <li>Wrote, edited and organized wiki pages relating to bioreactor modelling</li>
        </ul>
        </ReadAloud>
        
        <ReadAloud fontSize={`${16+fontSize}px`}>
        <h4 style={{fontSize: `${20+fontSize}px`}} className="page-name">Wendy Lu | Modelling Co-lead & Wiki Lead</h4><ul className="page-text">
        <li>Co-managed the Math and Modelling subteam</li>
        <li>Managed the Wiki subteam</li>
        <li>Co-organized and helped run fundraising initiatives</li>
        <li>Co-organized and co-ran the SHAD workshop</li>
        <li>Edited and organized wiki pages relating to metabolic engineering</li>
        </ul>
        </ReadAloud>
        
        <ReadAloud fontSize={`${16+fontSize}px`}>
        <h4 style={{fontSize: `${20+fontSize}px`}} className="page-name">Yosha Aneja | Wiki Member</h4><ul className="page-text">
        <li>Developed the wiki website</li>
        <li>Helped develop features for the accessibility toolbar</li>
        </ul>
        </ReadAloud>
        
        <ReadAloud fontSize={`${16+fontSize}px`}>
        <h4 style={{fontSize: `${20+fontSize}px`}} className="page-name">Youngwoo Lee | Wiki Member</h4><ul className="page-text">
        <li>Developed the wiki website</li>
        </ul>
        </ReadAloud>

    </div>)
}

export default TeamMembers;